import { hasLoadedConstants, mergeConstants } from '@/store/modules/constant/defaults';

const getters = {
  getConstant(state) {
    return mergeConstants(state.constants);
  },
  hasConstantCache(state) {
    return hasLoadedConstants(state.constants);
  },
  getInitializeState(state) {
    return state.initializeState ?? {};
  }
};

export default getters;
